var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdultsOnlyCrossPosition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 50.3C19.54 40.86 30.58 35.98 40.74 37.5C45.72 37.6 49.86 35.84 54.54 33.14C55.16 32.64 56.12 33.3 55.86 34.06C53.74 40.72 46.48 45.54 39.4 45.32C38.18 45.32 36.74 45.22 35.52 45.28C29.26 45.44 22.9 47.72 15.82 50.84C15.48 51.04 15.06 50.66 15.24 50.3H15.2Z",
    fill: "#00A6ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52005 26.8C12.1931 26.8 14.3601 24.6331 14.3601 21.96C14.3601 19.2869 12.1931 17.12 9.52005 17.12C6.847 17.12 4.68005 19.2869 4.68005 21.96C4.68005 24.6331 6.847 26.8 9.52005 26.8Z",
    fill: "#FF6AA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.48 31.2C57.1531 31.2 59.32 29.0331 59.32 26.36C59.32 23.687 57.1531 21.52 54.48 21.52C51.807 21.52 49.64 23.687 49.64 26.36C49.64 29.0331 51.807 31.2 54.48 31.2Z",
    fill: "#00A6ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 45C44.98 45.4 44.4401 45.54 44.24 45.22C41.94 42.38 40.18 38.08 37.02 36.56C30.96 35.6 26.62 37.26 23.64 39.3C21.96 38.34 20.54 37.02 19.68 35.68C17.38 32.76 17.2 30.6 13.52 29.32C11.46 27.9 15.14 26.78 16.42 26.76C19.58 26.48 23 29.08 24.9 30.72C26.64 32.06 27.24 32.58 28.7 32.74C33.22 29.88 38.94 27.34 42.84 33.7C44.88 37.38 45.18 41.04 45 45Z",
    fill: "#FF6AA0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.16 38.3999C37.92 38.0599 37.26 37.6799 37.04 37.2799C27.02 35.8799 19.5 40.9399 15.2 50.2999C15.02 50.6599 15.46 51.0399 15.78 50.8399C22.86 47.6999 29.22 45.4399 35.48 45.2799C36.7 45.2199 38.14 45.3199 39.36 45.3199C40.52 45.3599 41.66 45.2399 42.8 45.0199C42.2 42.8999 39.24 40.5799 38.14 38.3999H38.16Z",
    fill: "#00A6ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdultsOnlyCrossPosition);
export default __webpack_public_path__ + "static/media/adults_only_cross_position.009322f37d15b60b520320323b1608ba.svg";
export { ForwardRef as ReactComponent };